import styles from './styles.module.scss';

const TabsContainer = ({ tabs, selectedTab, setSelectedTab }) => {
  const selectedIndex = tabs.indexOf(selectedTab);
  const tabWidthPct = 100 / tabs.length;

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`${styles.tab} ${selectedTab === tab ? styles.active : ''}`}
            onClick={() => setSelectedTab(tab)}
          >
            {tab}
          </div>
        ))}
        <div
          className={styles.slider}
          style={{
            width: `calc(${tabWidthPct}% - 8px)`,
            transform: `translateX(calc(${selectedIndex * 100}% + ${selectedIndex * 8}px))`,
          }}
        />
      </div>
    </div>
  );
};

export default TabsContainer;
